import { render, staticRenderFns } from "./DeliveryListOnDeliveryPage.vue?vue&type=template&id=aa77fed0&scoped=true&"
import script from "./DeliveryListOnDeliveryPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryListOnDeliveryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa77fed0",
  null
  
)

export default component.exports